import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { fetchActivationRequirements, prepareAutomation, activateWithGrants } from '@/services/automations/automationSetupApi'

export function useAutomationSetup(automationId) {
  const client = useQueryClient()
  const query = useQuery({
    queryKey: ['do-chat', 'automation-setup', automationId],
    queryFn: () => fetchActivationRequirements(automationId),
    enabled: Boolean(automationId),
    retry: false,
  })
  const mutation = useMutation({
    mutationFn: ({ days }) => activateWithGrants({ automationId, cards: query.data?.cards ?? [], days }),
    onSuccess: () =>
      client.invalidateQueries({ queryKey: ['do-chat', 'automations'] }),
  })
  const preparation = useMutation({
    mutationFn: () => prepareAutomation(automationId),
    onSuccess: () => client.invalidateQueries({ queryKey: ['do-chat', 'automation-setup', automationId] }),
  })
  return {
    cards: query.data?.cards ?? [],
    blockers: query.data?.blockers ?? [],
    status: query.data?.status,
    semanticPlan: query.data?.semanticPlan ?? null,
    loading: query.isLoading,
    error: query.error,
    mutation,
    preparation,
  }
}
